import "@/App.css";
import { Toaster } from "sonner";
import { SmoothScroll } from "@/components/shared";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import AchievementCarousel from "@/components/AchievementCarousel";
import About from "@/components/About";
import IdealFit from "@/components/IdealFit";
import Experience from "@/components/Experience";
import Skills from "@/components/Skills";
import Portfolio from "@/components/Portfolio";
import Testimonials from "@/components/Testimonials";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AdminPage from "@/components/AdminPage";
import CosmicCursor from "@/components/CosmicCursor";
import AstralCursor from "@/components/AstralCursor";
import RecruiterChat from "@/components/RecruiterChat";

function Home() {
  return (
    <div className="App grain">
      <SmoothScroll />
      <AstralCursor />
      <CosmicCursor />
      <RecruiterChat />
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <AchievementCarousel />
        <About />
        <IdealFit />
        <Experience />
        <Skills />
        <Portfolio />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" richColors />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
